import device from './device/router.js'
export default [{
    path: 'device',
    name: 'device',
    component: r => require.ensure([], () => r(require('./index.vue')), 'device'),
    children: [
        device,
    ]
}]
